<template>
  <Panel header="Thêm thành viên nhận báo cáo">
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
          <label>Chọn tài khoản</label>
          <Dropdown v-model="customer" :options="listCustomer" optionLabel="name" placeholder="Chọn tài khoản" :filter="true" style="height: 35px" >
            <template #value="slotProps">
              <div class="flex align-items-center">
                <img v-if="slotProps.value.imageUrl" :src=slotProps.value.imageUrl style="width: 20px; margin-right: 3px" />
                <label style="width: 20px">{{ slotProps.value.name }}</label>
              </div>
            </template>
            <template #option="slotProps">
              <div class="flex align-items-center">
                <img v-if="slotProps.option.imageUrl" :src=slotProps.option.imageUrl style="width: 20px; margin-right: 3px" />
                <label style="width: 20px">{{ slotProps.option.name }}</label>
              </div>
            </template>
          </Dropdown>
        </div>
        <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
          <label>Thêm</label>
          <Button label="Đăng ký" icon="pi pi-plus-circle" iconPos="left" @click="doRegister()" />
        </div>
    </div>
  </Panel>
  <Panel header="Danh sách thành viên">
    <div class="p-fluid">
      <DataTable
          :value="listReceiver" :paginator="true" stripedRows
          :rows="10" :rowsPerPageOptions="[10,25,50]" :rowHover="true"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :globalFilterFields="['zaloName']"
          currentPageReportTemplate="Có tất cả {totalRecords} thành viên"
          v-model:filters="filters"
      >
        <Column field="imageLink" header="Ảnh đại diện" sortable>
          <template #body="slotProps">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-5 p-md-5">
                <img :src=slotProps.data.imageLink style="width: 60px" />
              </div>
            </div>
          </template>
        </Column>
        <Column field="zaloName" header="Họ và tên" sortable></Column>
        <Column header="Tuỳ chọn">
          <template #body="slotProps">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-5 p-md-5">
                <Button type="button" class="p-button-secondary" label="Xoá"  icon="pi pi-user-edit" @click="doDelete(slotProps.data.id)"></Button>
              </div>
            </div>
            <!--            </router-link>-->
          </template>
        </Column>
        <template #paginatorLeft>
        </template>
        <template #empty>
          Không có thông tin nhân viên.
        </template>
      </DataTable>
      <!--        </div>-->
    </div>
  </Panel>
</template>

<script lang="ts">

import { computed, ref } from 'vue'
import AuthRepository from '@/services/AuthRepository'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {Register} from "../models/register";
import {useStore} from "vuex";
import TeamRepository from "../services/TeamRepository";
import {Team} from "@/models/team.models";
import {ListCustomer} from "@/models/listCustomer";
import ZaloRepository from "@/services/ZaloRepository";
import {EmployeeCreate} from "@/models/employeeCreate";
import zaloRepository from "@/services/ZaloRepository";
import {ReceiverReportCreate} from "@/models/receiverReportCreate";
import {ReceiverReport} from "@/models/receiverReport";
import {FilterMatchMode} from "primevue/api";

export default {

  setup(){
    const router = useRouter();
    const register = ref({} as Register);
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const customer = ref({} as ListCustomer);
    const teamId = ref("");
    const listCustomer = ref([] as ListCustomer[]);

    const receiverReportCreate = ref({} as ReceiverReportCreate);
    const listReceiver = ref([] as ReceiverReport[]);

    const valid = computed(()=> register.value.password && register.value.username && register.value.team && register.value.fullname && register.value.address);

const getList = () => {
  ZaloRepository.getListCustomer()
      .then((response) => {
        listCustomer.value = response.data;
        getListReceiver();
      })
      .catch(err => {
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail:'Lỗi khi tải danh sách khách hàng',
          life: 2000
        });
      });
}
    getList();

    const getListReceiver = () => {
      ZaloRepository.getListReceiverReport()
          .then((response) => {
            listReceiver.value = response.data;
            listReceiver.value.forEach(x => {
              listCustomer.value.filter(y => {
                if(y.id == x.idZalo) x.imageLink = y.imageUrl;
                console.log("########## image link: " + x.imageLink);
              })
            });
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải danh sách thành viên',
              life: 2000
            });
          });
    }

    // getListReceiver();

    const doRegister = () => {
      receiverReportCreate.value.idZalo = customer.value.id;
      receiverReportCreate.value.zaloName = customer.value.name;
        zaloRepository.createReceiverReport(receiverReportCreate.value)
                .then((response) => {
                  toast.add({
                    severity: 'success',
                    summary: 'Đăng ký',
                    detail: 'Đăng ký thành viên thành công vào hệ thống',
                    life: 2000
                  });
                  getListReceiver();
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail:err.response.data,
                    life: 2000
                  });
                });
    }

    const doDelete = (id: number) => {
      zaloRepository.deleteReceiverReport(id)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Xoá',
              detail: 'Xoá thành viên thành công khỏi hệ thống',
              life: 2000
            });
            getListReceiver();
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    return {
      register,
      doRegister,
      valid,
      error,
      listCustomer,
      customer,
      teamId,
      listReceiver,
      doDelete,
      filters,
      clearFilter,
      initFilters,
    }
  }
}

</script>
